import { SharedItemPatientSendingSettingsResponse } from "@/Common/Api/Patient/Dto/SharedItemPatientSendingSettings";

export class SharedItemPatientSendingSettings {
    public patientContactFacetId: string;
    public blockedByUserId?: string;
    public blockedDate?: string;
    public blockedReason?: string;
    public messagesLimit?: number;
    public remainingMessages?: number;

    public get parsedBlockedDate(): Date {
        return this.blockedDate ? new Date(this.blockedDate) : null;
    }

    public constructor(init?: Partial<SharedItemPatientSendingSettings>) {
        Object.assign(this, init);
    }

    public static fromResponse(settings: SharedItemPatientSendingSettingsResponse): SharedItemPatientSendingSettings {
        if (settings == null)
            return null;

        return new SharedItemPatientSendingSettings({
            patientContactFacetId: settings.PatientContactFacetId,
            blockedByUserId: settings.BlockedByUserId,
            blockedDate: settings.BlockedDate,
            blockedReason: settings.BlockedReason,
            messagesLimit: settings.MessagesLimit,
            remainingMessages: settings.RemainingMessages
        });
    }
}
